// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-vXZv","modalQuestionWrapper":"styles_modalQuestionWrapper__x6eUY","extraText":"styles_extraText__NPoEc"};